// 100% browser identification can not be garantueed. Should be considered a best guess
export function getBrowser() {
  const { userAgent } = navigator;
  let browserName = 'unknown';
  let fullVersion = '';
  let majorVersion = '';

  if (userAgent) {
    if (userAgent.includes('Opera')) {
      const verOffset = userAgent.indexOf('Opera');
      browserName = 'Opera';
      fullVersion = userAgent.substring(verOffset + 6);
      if (userAgent.includes('Version')) {
        const offset = userAgent.indexOf('Version');
        fullVersion = userAgent.substring(offset + 8);
      }
    } else if (userAgent.includes('Edg')) {
      const verOffset = userAgent.indexOf('Edg');
      browserName = 'Edge';
      fullVersion = userAgent.substring(verOffset + 7);
      if (userAgent.includes('Version')) {
        const offset = userAgent.indexOf('Version');
        fullVersion = userAgent.substring(offset + 8);
      }
    } else if (userAgent.includes('Chrome')) {
      const verOffset = userAgent.indexOf('Chrome');
      browserName = 'Chrome';
      fullVersion = userAgent.substring(verOffset + 7);
    } else if (userAgent.includes('Safari')) {
      const verOffset = userAgent.indexOf('Safari');
      browserName = 'Safari';
      fullVersion = userAgent.substring(verOffset + 7);
      if (userAgent.includes('Version')) {
        const offset = userAgent.indexOf('Version');
        fullVersion = userAgent.substring(offset + 8);
      }
    } else if (userAgent.includes('Firefox')) {
      const verOffset = userAgent.indexOf('Firefox');
      browserName = 'Firefox';
      fullVersion = userAgent.substring(verOffset + 8);

      // In most other browsers, "name/version" is at the end of userAgent
    } else if (userAgent.lastIndexOf(' ') + 1 < userAgent.lastIndexOf('/')) {
      const nameOffset = userAgent.lastIndexOf(' ') + 1;
      const verOffset = userAgent.lastIndexOf('/');
      browserName = userAgent.substring(nameOffset, verOffset);
      fullVersion = userAgent.substring(verOffset + 1);
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    if (fullVersion) {
      // trim the fullVersion string at semicolon/space if present
      if (fullVersion.includes(';')) {
        const ix = fullVersion.indexOf(';');
        fullVersion = fullVersion.substring(0, ix);
      }
      if (fullVersion.includes(' ')) {
        const ix = fullVersion.indexOf(' ');
        fullVersion = fullVersion.substring(0, ix);
      }
      majorVersion = parseInt(`${fullVersion}`, 10);
      if (!majorVersion && navigator && navigator.appVersion) {
        fullVersion = `${parseFloat(navigator.appVersion)}`;
        majorVersion = parseInt(navigator.appVersion, 10);
      }
    }
  }

  return `${browserName}${majorVersion}`;
}

export function getOS() {
  let OSName = 'unknown';
  if (navigator && navigator.appVersion) {
    if (navigator.appVersion.includes('Win')) OSName = 'Windows';
    if (navigator.appVersion.includes('Mac')) OSName = 'MacOS';
    if (navigator.appVersion.includes('X11')) OSName = 'UNIX';
    if (navigator.appVersion.includes('Linux')) OSName = 'Linux';
  }
  return OSName;
}
